import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';

export const Container = styled.div`
  max-width: ${BREAKPOINTS.max}px;
  padding-left: 30px;
  padding-right: 30px;
  margin: auto;

  ${mediaQuery('phone')} {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const MtFormContainer = styled(Container)`
  max-width: ${BREAKPOINTS.medium}px;
`;
